module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-google-recaptcha/~/babel-runtime/core-js/object/assign.js
 ** module id = 2829
 ** module chunks = 0
 **/